export default __webpack_public_path__ + "static/media/Hypermarket W00 Regular.8a71ba5f.ttf";